import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TotalSalesBreakdownButton from './TotalSalesBreakdownButton';
import TotalSalesBreakdownTable from './TotalSalesBreakdownTable';

class TotalSalesBreakdown extends Component {
  static propTypes = {
    toggle: PropTypes.func.isRequired,
    isOn: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    totals: PropTypes.shape({
      quantity: PropTypes.number,
      grossTotal: PropTypes.number,
      grossRefunds: PropTypes.number,
      grossPromo: PropTypes.number,
      grossDiscounts: PropTypes.number,
      netTotal: PropTypes.number,
      tax: PropTypes.number,
      tips: PropTypes.number,
      totalCollected: PropTypes.number,
      fees: PropTypes.number,
      loanRepaymentCharge: PropTypes.number,
    }).isRequired,
    showCountInTotal: PropTypes.bool,
    totalTitle: PropTypes.string.isRequired,
    serviceProductTitle: PropTypes.string.isRequired,
  }
  static defaultProps = {
    showCountInTotal: false,
  }

  state = { active: true };

  handleClick = () => {
    this.setState({
      active: !this.state.active,
    });
  }

  render() {
    return (
      <div className="u-mb+">
        <TotalSalesBreakdownTable
          display-if={this.props.isOn}
          data={this.props.data}
          totals={this.props.totals}
          showCountInTotal={this.props.showCountInTotal}
          totalTitle={this.props.totalTitle}
          serviceProductTitle={this.props.serviceProductTitle}
        />
        <TotalSalesBreakdownButton
          onClick={this.props.toggle}
          active={this.props.isOn}
        />
      </div>
    );
  }
}

export default TotalSalesBreakdown;
